import { Nullable } from "@core/domain/types/nullable.type";
import { injectable } from "inversify";
import { IrpfRetentionTypeEnumDto } from "@entity/data/dto/irpf-retention-type.dto";
import { IrpfRetentionTypeEnum } from "@entity/domain/models/irpf-retention-type.model";

@injectable()
export class IrpfRetentionEnumMapper {
    map(
        irpfRetentionTypeEnumDto: IrpfRetentionTypeEnumDto,
    ): Nullable<IrpfRetentionTypeEnum> {
        switch (irpfRetentionTypeEnumDto) {
            case IrpfRetentionTypeEnumDto.yes:
                return IrpfRetentionTypeEnum.yes;
            case IrpfRetentionTypeEnumDto.no:
                return IrpfRetentionTypeEnum.no;
            default:
                return null;
        }
    }

    mapToDto(
        irpfRetentionTypeEnum: IrpfRetentionTypeEnum,
    ): IrpfRetentionTypeEnumDto {
        switch (irpfRetentionTypeEnum) {
            case IrpfRetentionTypeEnum.yes:
                return IrpfRetentionTypeEnumDto.yes;
            case IrpfRetentionTypeEnum.no:
                return IrpfRetentionTypeEnumDto.no;
        }
    }
}